<template>
  <div>
    <v-container>
      <h1>用最简单的方法写出最有用的代码</h1>
      <v-list>
        <v-list-item-subtitle>代码生成:</v-list-item-subtitle>
        <v-list-item v-for="(item,index) of makerTemplates" :key="index" @click="$router.push(`/maker/${item.id}`)">
          <v-list-item-content>
            <v-list-item-title>{{ item.label }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Home',
  data: () => ({
    makerTemplates: {}
  }),
  created() {
    axios.get("/makerTemplates.json").then(d => {
      this.makerTemplates = d.data
    })
  }
}
</script>
<style scoped lang="sass">
h1
  text-align: center
</style>